module.exports = __webpack_public_path__ + "static/media/ProximaNova-Extrabld.ccf59c77.woff";